import React, { Component } from 'react';
import { message } from 'antd';
import { connect } from 'react-redux';
import { BackBtn } from '@comm/BackBtn';
import { queryBusinessInfo } from '@api/common/business';
import CardBase from './AddressBase';

class BaseForm extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillMount() {}

  componentDidMount() {
    this.businessInfo();
  }

  businessInfo = () => {
    queryBusinessInfo({
      businessUuid: this.props.params.uuid,
    }).then(res => {
      if (res.statusCode !== 200) {
        message.error(res.message);
      }
    });
  };

  render() {
    return (
      <div>
        <div className="mb16">
          <BackBtn />
        </div>
        <CardBase {...this.props} />
      </div>
    );
  }
}

export default connect(state => ({ organization: state.organization }))(BaseForm);



// WEBPACK FOOTER //
// ./src/components/incubator/contract/detail/AddressFree.js